import fetchApi from "../fetchApi";

// Current user's IIP profile, including the dynamic `permissions` map
// ({ "category.feature": { read, write, delete } }) that drives RBAC UI gating.
// Sourced from users/me, not the legacy auth/current-user endpoint which does
// not carry permissions.
export const GetMyPermissions = async () => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi("users/me", options);
};
